<template>
  <v-card-text class="px-0">
    <v-row no-gutters>
      <v-col cols="6" class="pr-3">
        <v-row no-gutters class="mb-7">
          <v-select
            hide-details
            outlined
            :items="symbolizationTypeItems"
            :label="$i18n.t('settings.layersList.symblizationType')"
            v-model="computedStyle.type"
            @change="changeStyleType"
          />
        </v-row>
        <template v-if="computedStyle.type === 'unique'">
          <v-row no-gutters class="mb-8">
            <v-select
              hide-details
              outlined
              :items="sortedLayersAttributes"
              :item-text="$i18n.locale"
              item-value="name"
              :label="$i18n.t('settings.layersList.attribute')"
              v-model="computedStyle.attribute"
              @change="changeStyleAttribute"
            />
          </v-row>
          <v-row
            v-if="computedStyle.attribute && isClassificationTranslate"
            no-gutters
            class="mb-5"
          >
            <v-select
              hide-details
              outlined
              :items="classificationTranslateItems"
              :label="$i18n.t('settings.layersList.classificationTranslate')"
              v-model="computedStyle.classificationTranslate"
            />
          </v-row>
          <v-row
            v-if="
              computedStyle.attribute && isClassificationTranslate
                ? computedStyle.classificationTranslate
                : computedStyle.attribute
            "
            no-gutters
            class="mb-7"
          >
            <v-btn
              small
              class="primary"
              :loading="isClassifying"
              @click="classifyUniques"
            >{{ $i18n.t('settings.layersList.classify') }}</v-btn>
          </v-row>
          <v-row
            v-if="computedStyle.attribute && computedStyle.uniques && !isClassifying"
            no-gutters
            class="uniques-list"
          >
            <v-col cols="auto">
              <v-row
                v-for="(unique, idx) of sortedComputedStyleUniques"
                :key="idx"
                no-gutters
                class="unique-element pa-1 px-2 mb-2"
                :class="{
                  'unique-element-active': activeUniqueClass === unique.value,
                  'unique-element-disabled': isUniquesDisabled
                }"
                align="center"
                @click="setActiveUniqueClass(unique.value)"
              >
                <v-col cols="auto" class="pa-0 mr-1">
                  <v-icon
                    size="25"
                    :color="isUniquesDisabled ? '#bababa' : unique.fillColor"
                  >mdi-square-rounded</v-icon>
                </v-col>
                <v-col
                  class="text-body-2 unique-value pa-0"
                  :class="{
                    'unique-value-active': activeUniqueClass === unique.value,
                    'unique-value-disabled': isUniquesDisabled
                  }"
                >{{ unique.value }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </v-col>
      <v-col cols="6" class="pl-3" v-if="!isClassifying">
        <layer-style-single
          v-if="computedStyle.type === 'single' || (computedStyle.type === 'unique' && (activeUniqueClass === '' || activeUniqueClass == '0' || activeUniqueClass))"
          :is-style-valid.sync="isSingleStyleValid"
          :singleStyle.sync="
            computedStyle.type === 'single'
              ? computedStyle
              : this.computedStyle.uniques[this.activeUniqueClass.toString()]
          "
          :geometry-type="geometryType"
        />
      </v-col>
    </v-row>
  </v-card-text>
</template>
<script>
export default {
  components: {
    LayerStyleSingle: () => import('@/components/settings/LayerStyleSingle')
  },
  props: {
    isNewUserLayer: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    geometryType: {
      type: String,
      default: () => {
        return 'point';
      }
    },
    layerAttributes: {
      type: Array,
      default: () => {
        return [];
      }
    },
    layerId: {
      type: [Number, String]
    },
    layerStyle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    attributeObject() {
      return this.layerAttributes.find(attribute => attribute.name === this.computedStyle.attribute);
    },
    computedStyle: {
      get() {
        return this.layerStyle;
      },
      set(nV) {
        this.$emit('update:layerStyle', nV);
      }
    },
    isClassificationTranslate() {
      return this.attributeObject.translate || false;
    },
    isStyleValid() {
      if (this.computedStyle.type === 'single') {
        return true;
      } else if (this.computedStyle.type === 'unique') {
        return Object.keys(this.computedStyle.uniques).length > 0;
      } else {
        return false;
      }
    },
    isUniquesDisabled() {
      return (
        (this.activeUniqueClass === '' || this.activeUniqueClass == '0' || this.activeUniqueClass) &&
        !this.isSingleStyleValid
      );
    },
    sortedComputedStyleUniques() {
      return JSON.parse(JSON.stringify(Object.values(this.computedStyle.uniques))).sort((a, b) => {
        return (a.value || '').toString().toLowerCase() > (b.value || '').toString().toLowerCase() ? 1 : -1;
      });
    },
    sortedLayersAttributes() {
      return JSON.parse(JSON.stringify(this.layerAttributes)).sort((a, b) => {
        return a[this.$i18n.locale] > b[this.$i18n.locale] ? 1 : -1;
      });
    },
    symbolizationTypeItems() {
      const items = [
        {
          value: 'single',
          text: vm.$i18n.t('settings.layersList.singleSymbolization')
        }
      ];
      if (!this.isNewUserLayer) {
        items.push({
          value: 'unique',
          text: vm.$i18n.t('settings.layersList.uniqueSymbolization')
        });
      }
      return items;
    }
  },
  data: vm => ({
    activeUniqueClass: null,
    classificationTranslateItems: [
      {
        value: 'pl',
        text: vm.$i18n.t('settings.layersList.polishClassificationTranslate')
      },
      {
        value: 'en',
        text: vm.$i18n.t('settings.layersList.englishClassificationTranslate')
      }
    ],
    isClassifying: false,
    isSingleStyleValid: false
  }),
  methods: {
    changeStyleAttribute(nV) {
      if (this.computedStyle.type === 'unique') {
        delete this.computedStyle.classificationTranslate;
        this.computedStyle.uniques = {};
      }
      this.activeUniqueClass = null;
    },
    changeStyleType(nV) {
      if (nV === 'single') {
        this.computedStyle = {
          type: 'single',
          fillColor: '#00A99D',
          strokeColor: '#00A99D',
          strokeWidth: 1,
          opacity: 0
        };
      } else if (nV === 'unique') {
        this.computedStyle = {
          type: 'unique',
          attribute: '',
          uniques: {}
        };
      }
      this.activeUniqueClass = null;
    },
    async classifyUniques() {
      this.isClassifying = true;
      const payload = {
        id: this.layerId,
        attribute: this.computedStyle.attribute,
        language: this.attributeObject.translate ? this.computedStyle.classificationTranslate : undefined
      };
      const response = await this.$store.dispatch('getUniques', payload);
      if (response.status === 400) {
        this.$root.$emit('showSnackbar', this.$i18n.t(`settings.layersList.tooManyUniqueValues`));
        this.isClassifying = false;
        return;
      }
      const uniques = {};
      for (const unique of response.data.data) {
        if (this.attributeObject.type === 'multiselect') {
          const joinArray = Array.isArray(unique.value)
            ? unique.value
                .sort((a, b) => {
                  return (a || '').toString().toLowerCase() > (b || '').toString().toLowerCase() ? 1 : -1;
                })
                .join(', ')
            : unique.value;
          uniques[joinArray] = unique;
          uniques[joinArray].value = joinArray;
        } else {
          uniques[unique.value] = unique;
        }
      }
      this.computedStyle.uniques = uniques;
      const keys = Object.keys(this.computedStyle.uniques);
      if (keys.length > 0) {
        this.activeUniqueClass = keys[0];
      } else {
        this.$root.$emit('showSnackbar', this.$i18n.t(`settings.layersList.noClasses`));
      }
      this.isClassifying = false;
    },
    setActiveUniqueClass(value) {
      if (this.isUniquesDisabled) {
        return;
      }
      this.activeUniqueClass = value;
    }
  },
  watch: {
    isStyleValid(nV) {
      this.$emit('update:isStyleValid', nV && this.isSingleStyleValid);
    },
    isSingleStyleValid(nV) {
      this.$emit('update:isStyleValid', nV && this.isStyleValid);
    },
    layerId(nV) {
      if ((!nV && nV != '0') || !this.computedStyle.uniques) {
        return;
      }
      if (this.sortedComputedStyleUniques.length > 0) {
        this.activeUniqueClass = this.sortedComputedStyleUniques[0].value;
      }
    }
  },
  mounted() {
    if (this.computedStyle.uniques) {
      if (this.sortedComputedStyleUniques.length > 0) {
        this.activeUniqueClass = this.sortedComputedStyleUniques[0].value;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.unique-element {
  background: rgba(121, 121, 121, 0.12);
  border: 0.7px solid rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  cursor: pointer;
}
.unique-element-active {
  border: 1.8px solid #00a99d !important;
}
.unique-element-disabled {
  cursor: default !important;
}
.unique-value {
  font-style: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.87);
  margin-top: 2px;
}
.unique-value-active {
  font-weight: 500;
}
.unique-value-disabled {
  color: #bababa;
}
.uniques-list {
  max-height: 35vh;
  overflow: auto;
}
</style>